import React, { useState, useEffect } from "react";
import LandingNavBar from "../navBar/LandingNavBar";
import MultiStepForm from "./MultiStepForm";
import LandingFooter from "../navBar/LandingFooter";
import CarMultiStepForm from "../carLoanProcess/CarMultiStepForm";
import jalifinance_logo from "../images/jalifinance_logo.png";
const STORAGE_KEY = "loan_selected_vehicle_type";

const vehicles = [
  {
    id: "car",
    label: "Car Loan",
    subtitle: "Sedans, SUVs, Trucks & more",
    icon: (
      <svg viewBox="0 0 64 32" fill="none" className="w-16 h-10">
        <rect x="8" y="12" width="48" height="14" rx="3" fill="currentColor" opacity="0.15" />
        <path
          d="M10 18 L16 10 Q18 8 21 8 L43 8 Q46 8 48 10 L54 18 L56 18 Q58 18 58 20 L58 22 Q58 24 56 24 L52 24 Q52 28 48 28 Q44 28 44 24 L20 24 Q20 28 16 28 Q12 28 12 24 L8 24 Q6 24 6 22 L6 20 Q6 18 8 18 Z"
          fill="currentColor"
          opacity="0.9"
        />
        <circle cx="16" cy="25" r="3" fill="currentColor" opacity="0.5" />
        <circle cx="48" cy="25" r="3" fill="currentColor" opacity="0.5" />
        <rect x="20" y="10" width="10" height="8" rx="1.5" fill="white" opacity="0.3" />
        <rect x="34" y="10" width="10" height="8" rx="1.5" fill="white" opacity="0.3" />
      </svg>
    ),
  },
  {
    id: "motorbike",
    label: "Motorbike Loan",
    subtitle: "Bikes & Motorcycles",
    icon: (
      <svg viewBox="0 0 64 40" fill="none" className="w-16 h-10">
        <circle cx="14" cy="28" r="9" stroke="currentColor" strokeWidth="3" opacity="0.9" fill="none" />
        <circle cx="50" cy="28" r="9" stroke="currentColor" strokeWidth="3" opacity="0.9" fill="none" />
        <circle cx="14" cy="28" r="3" fill="currentColor" opacity="0.5" />
        <circle cx="50" cy="28" r="3" fill="currentColor" opacity="0.5" />
        <path d="M14 28 L28 14 L38 14 L50 28" stroke="currentColor" strokeWidth="3" strokeLinecap="round" opacity="0.9" fill="none" />
        <path d="M28 14 L30 8 L36 8 L38 14" fill="currentColor" opacity="0.6" />
        <path d="M38 14 L46 20 L50 20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.8" fill="none" />
      </svg>
    ),
  },
];

const ApplicationForm = () => {
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "car" || saved === "motorbike") {
      setSelectedVehicle(saved);
    }
  }, []);

  const handleSelect = (id) => {
    if (selectedVehicle === id) return;
    setAnimating(true);
    setTimeout(() => {
      setSelectedVehicle(id);
      localStorage.setItem(STORAGE_KEY, id);
      setAnimating(false);
    }, 250);
  };

  const handleReset = () => {
    setAnimating(true);
    setTimeout(() => {
      setSelectedVehicle(null);
      localStorage.removeItem(STORAGE_KEY);
      setAnimating(false);
    }, 250);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-[#20409A] to-blue-900">
      <LandingNavBar />

      <div className="flex flex-col items-center justify-start min-h-[80vh] w-full bg-white">

        {/* ── Selection Screen ── */}
        {!selectedVehicle && (
          <div className="w-full min-h-[80vh] bg-gradient-to-br from-gray-900 via-[#20409A] to-blue-900 flex flex-col items-center justify-center px-4 py-12 relative overflow-hidden">

            {/* Ambient blobs */}
            <div className="absolute top-[-80px] left-[-80px] w-80 h-80 bg-blue-500/20 rounded-full blur-3xl animate-pulse" />
            <div className="absolute bottom-[-60px] right-[-60px] w-72 h-72 bg-indigo-400/20 rounded-full blur-3xl animate-pulse [animation-delay:1.2s]" />
            <div className="absolute top-1/2 left-1/3 w-48 h-48 bg-cyan-300/10 rounded-full blur-2xl animate-pulse [animation-delay:2.5s]" />

            {/* Brand header */}
            <div className="relative z-10 flex flex-col items-center mb-10" style={{ animation: "fadeSlideDown 0.6s ease both" }}>
              {/* Logo */}
              <div className="flex items-center gap-2.5 mb-5">
                <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center ">
                  {/* <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                  </svg> */}
                   <img src={jalifinance_logo} alt="logo" className="h-8 sm:h-10 w-auto" />
                </div>
                <span className="text-white font-extrabold text-2xl tracking-tight">
                  JALI<span className="text-red-600">FINANCE</span>
                </span>
              </div>

              <div className="flex items-center gap-3 mb-6">
                <div className="h-px w-10 bg-blue-400/40" />
                <p className="text-blue-300 text-xs font-semibold tracking-[0.2em] uppercase">
                  Vehicle Loan Application
                </p>
                <div className="h-px w-10 bg-blue-400/40" />
              </div>

              <h1 className="text-white text-4xl md:text-5xl font-extrabold text-center leading-tight mb-3">
                What are you
                <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-cyan-300">
                  applying for?
                </span>
              </h1>

              <p className="text-blue-300/75 text-center text-sm max-w-xs">
                Select your vehicle type below to begin your secure loan application
              </p>
            </div>

            {/* Vehicle Cards */}
            <div className="relative z-10 flex flex-col sm:flex-row gap-5 w-full max-w-lg">
              {vehicles.map((v, i) => (
                <button
                  key={v.id}
                  onClick={() => handleSelect(v.id)}
                  style={{ animation: `fadeSlideUp 0.5s ease ${0.25 + i * 0.15}s both` }}
                  className="flex-1 group relative rounded-2xl border border-white/15 bg-white/5 backdrop-blur-sm p-8
                    flex flex-col items-center gap-4 cursor-pointer focus:outline-none
                    hover:bg-white/10 hover:border-blue-400/60 hover:scale-105
                    hover:shadow-[0_8px_40px_rgba(96,165,250,0.25)]
                    transition-all duration-300 ease-out overflow-hidden"
                >
                  {/* Card hover gradient wash */}
                  <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-400/0 to-cyan-400/0 group-hover:from-blue-400/10 group-hover:to-cyan-400/5 transition-all duration-500" />

                  {/* Icon bubble */}
                  <div className="relative w-20 h-20 rounded-2xl bg-white/10 group-hover:bg-blue-500/20
                    flex items-center justify-center
                    transition-all duration-300 group-hover:scale-110 group-hover:shadow-sm group-hover:shadow-blue-400/30">
                    <div className="text-white/60 group-hover:text-blue-300 transition-colors duration-300">
                      {v.icon}
                    </div>
                  </div>

                  {/* Label */}
                  <div className="text-center">
                    <p className="font-bold text-lg text-white/85 group-hover:text-white transition-colors duration-300 mb-1 uppercase">
                      {v.label}
                    </p>
                    <p className="text-xs text-white/45 group-hover:text-blue-200 transition-colors duration-300">
                      {v.subtitle}
                    </p>
                  </div>

                  {/* Apply now CTA — fades in on hover */}
                  <div className="flex items-center gap-1.5 text-blue-400 opacity-0 group-hover:opacity-100 transition-all duration-300 text-xs font-semibold -translate-y-1 group-hover:translate-y-0">
                    <span>Apply now</span>
                    <svg className="w-3.5 h-3.5 translate-x-0 group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                  </div>

                  {/* Bottom accent bar */}
                  <div className="absolute bottom-0 left-1/2 -translate-x-1/2 h-0.5 w-0 group-hover:w-2/3 rounded-full bg-gradient-to-r from-blue-400 to-cyan-400 transition-all duration-500" />
                </button>
              ))}
            </div>

            {/* Trust badge */}
            <div
              className="relative z-10 mt-10 flex items-center gap-2 text-white/30 text-xs"
              style={{ animation: "fadeSlideUp 0.5s ease 0.6s both" }}
            >
              <svg className="w-3.5 h-3.5 text-blue-400/60" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              </svg>
              <span>Secure &amp; confidential · Powered by JALIGROUP </span>
            </div>

            <style>{`
              @keyframes fadeSlideDown {
                from { opacity: 0; transform: translateY(-24px); }
                to   { opacity: 1; transform: translateY(0); }
              }
              @keyframes fadeSlideUp {
                from { opacity: 0; transform: translateY(24px); }
                to   { opacity: 1; transform: translateY(0); }
              }
            `}</style>
          </div>
        )}

        {/* ── Form Screen ── */}
        {selectedVehicle && (
          <div
            className={`w-full flex flex-col items-center transition-all duration-300 ${
              animating ? "opacity-0 translate-y-4" : "opacity-100 translate-y-0"
            }`}
          >
            {/* Slim back bar */}
            <div className="w-full bg-gradient-to-r from-gray-900 via-[#20409A] to-blue-900 px-6 py-3 flex items-center gap-3">
              <button
                onClick={handleReset}
                className="flex items-center gap-1.5 text-blue-200 hover:text-white text-sm transition-colors duration-200"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
                Change selection
              </button>
              <span className="text-white/30 text-sm">|</span>
              <span className="text-white text-sm font-semibold uppercase">
                {vehicles.find((v) => v.id === selectedVehicle)?.label}
              </span>
            </div>

            {selectedVehicle === "car" && <CarMultiStepForm />}
            {selectedVehicle === "motorbike" && <MultiStepForm />}
          </div>
        )}
      </div>

      <LandingFooter />
    </div>
  );
};

export default ApplicationForm;